import { Container, Flex, Link, Text } from "@chakra-ui/react";
import { Breadcrumb, PreviousButton } from "components";
import { CheckboxCard } from "components/CheckboxCard";
import { Heading } from "elements";
import { useState } from "react";
import { routes } from "utils";
import { BookingStepsLabels, PayOffOptions, PayOffOptionsEnum } from "utils/enums";
import { BookDetailsTile } from "./BookDetailsTile";

const HowToPay = () => {
  const [amount] = useState<number>(1.595);

  const [howToPay, setHowToPay] = useState<PayOffOptions>({
    payAtProperty: false,
    payFull: false,
    payPartially: false
  });

  const onHowToPayChange = (label: keyof PayOffOptions, value: boolean) => {
    let data = {
      payAtProperty: false,
      payFull: false,
      payPartially: false
    };
    data[label] = value;
    setHowToPay(data);
  };

  return (
    <>
      <PreviousButton />
      <Container marginTop={5} marginLeft={0} marginBottom={5} paddingLeft={0}>
        <Heading title="Payment" color="#1F1E1E" fontWeight={700} />
      </Container>
      <Breadcrumb color="#1F1E1E" linkList={[{ link: '#', title: BookingStepsLabels.STEP_1 }]} />
      <Container marginTop={50} marginLeft={0} marginBottom={5} paddingLeft={0}>
        <Heading fontSize="32px" title="1.  Choose how to pay" color="#3498FE" fontWeight={700} />
      </Container>
      <Flex flexDirection={['column', 'column', 'column', 'row']} justifyContent='space-between' gap={[10]}>
        <Flex flexDirection='column'>
          <CheckboxCard
            title='Pay full now'
            subtitle='Pay the total amount and you are all good.'
            amount={amount}
            isChecked={howToPay.payFull}
            label={PayOffOptionsEnum.PAY_FULL}
            onChange={onHowToPayChange}
          />
          <CheckboxCard
            title='Pay at property'
            subtitle={<> Reserve your booking and pay when you check-in.{' '}
              <Link href='#'>More info</Link></>}
            amount={amount}
            isChecked={howToPay.payAtProperty}
            label={PayOffOptionsEnum.PAY_AT_PROPERTY}
            onChange={onHowToPayChange}
          />
          <CheckboxCard
            title='Pay partly now, part at property'
            subtitle={<> Part amount charged now, part later by selected payment method.{' '}
              <Link href='#'>More info</Link></>}
            amount={amount}
            isChecked={howToPay.payPartially}
            label={PayOffOptionsEnum.PAY_PARTIALLY}
            onChange={onHowToPayChange}
          />

          <Flex width={['100%']}>
            <Text color='#6F6F6F' fontWeight={500} fontSize="16px" fontFamily="Montserrat">
              By selecting the button below, I agree to{' '}
              <Link color='#3498FE' href='#'>Ollie’s Rebooking and Refund Policy, Pay Less Upfront Terms,</Link> and that Ollie can <Link color='#3498FE' href='#'> charge my payment</Link> method if I’m responsible for damage.
            </Text>
          </Flex>
        </Flex>
        <BookDetailsTile price={300} nights={5}
          type="Stays" title="Bucharest" numberOfReviews={20} rating={5} url={routes.BOOKING.PAYMENT_METHOD} image="https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg" housekeepingFee={0} platformFee={0} parkingFee={5} />
      </Flex>
    </>
  );
};

export { HowToPay };
